import { AuthToken } from 'entities/user';
import { APP_LOG } from '../../constants';
import parseJWT from './parseJWT'; 

export interface TokenPayload {
  login: string;
  userType: string;
  clientCode: string;
  clientId: string;
  accessToken: string;
  refreshToken: string;
  expiryTime: number;
  contourType: number;
}

const parseAuthData = ({
  access_token,
  refresh_token
}: AuthToken['data']): TokenPayload => {
  const tokenPayload: TokenPayload = {
    accessToken: access_token,
    refreshToken: refresh_token
  } as TokenPayload;

  try {
    const {
      exp,
      'http://schemas.zgs.loc/e100/identity/claims/login': login,
      'http://schemas.zgs.loc/e100/identity/claims/usertype': userType,
      'http://schemas.zgs.loc/e100/identity/claims/clientcode': clientCode,
      'http://schemas.zgs.loc/e100/identity/claims/clientid': clientId,
      'http://schemas.zgs.loc/e100/identity/claims/contureType': contourType
    } = parseJWT(tokenPayload.accessToken);

    tokenPayload.login = login;
    tokenPayload.userType = userType;
    tokenPayload.clientCode = clientCode;
    tokenPayload.clientId = clientId;
    tokenPayload.expiryTime = Number(exp);
    tokenPayload.contourType = Number(contourType);
  } catch (error) {
    console.info(APP_LOG.JWT.ERROR_PARSE, error);
  }

  return tokenPayload;
};

export default parseAuthData;
